import { Link, useNavigate } from "react-router-dom";
import { getUser, clearAuth, isAuthed } from "@/lib/api";
import { LogOut, LayoutGrid } from "lucide-react";

export default function Nav() {
  const user = getUser();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#070C18]/80 border-b border-slate-800/60" data-testid="app-nav">
      <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#38BDF8] to-[#F59E0B] grid place-items-center text-[#070C18] font-bold">Q</div>
          <span className="font-serif text-xl tracking-tight">DualQ</span>
        </Link>
        <nav className="flex items-center gap-2 text-sm">
          {isAuthed() ? (
            <>
              <Link to="/dashboard" className="px-3 py-2 rounded-lg hover:bg-slate-800/60 flex items-center gap-1.5" data-testid="nav-dashboard">
                <LayoutGrid className="w-4 h-4" /> Dashboard
              </Link>
              {user?.role === "SUPER_ADMIN" && (
                <Link to="/admin" className="px-3 py-2 rounded-lg hover:bg-slate-800/60 text-[#E0A96D]" data-testid="nav-admin">Admin</Link>
              )}
              <button
                onClick={() => { clearAuth(); nav("/"); }}
                className="px-3 py-2 rounded-lg hover:bg-slate-800/60 flex items-center gap-1.5 text-slate-400"
                data-testid="nav-logout"
              >
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </>
          ) : (
            <Link to="/auth" className="px-4 py-2 rounded-lg bg-[#E0A96D] text-[#070C18] font-medium hover:bg-[#F0C28B]" data-testid="nav-signin">
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
